<script>
import { signTheUserOut } from "@/services/UserServices";

export default {
  methods: {
    async signOut() {
      await signTheUserOut();
      await this.$store.dispatch('isAuthenticated', false);
      this.$router.push('/');
    }
  },
  created() {
    this.signOut();
  },
}
</script>
